import {
    ColumnDatatable,
    FiltersDatatableList,
    PreFilterDatatableList,
    RowSelectionActionList,
    StoreDatatable,
} from '@europrocurement/flexy-datatable';
import { DataSource, getDataThunkType } from '@europrocurement/l2d-redux-utils';
import { SxProps } from '@mui/system';
import React from 'react';
import { FactureOpenSearch, useSociete } from '@europrocurement/l2d-domain';

export type FacturesTableProps = {
    fetchData: getDataThunkType<FactureOpenSearch>;
    datasource: DataSource<FactureOpenSearch>;
    columns: ColumnDatatable<FactureOpenSearch>[];
    preFilters?: PreFilterDatatableList;
    filters: FiltersDatatableList;
    rowActions?: RowSelectionActionList;
    onRowClick: (item: FactureOpenSearch) => void;
};

const FacturesTable: React.FunctionComponent<FacturesTableProps> = function ({
    fetchData,
    datasource,
    columns,
    preFilters,
    filters,
    rowActions,
    onRowClick: handleRowClick,
}) {
    const xIdSociete = useSociete();
    return (
        <>
            {/* <QuickFilterFactureTable /> */}
            <StoreDatatable
                dataSource={datasource}
                columns={columns}
                computeSxRow={(item: FactureOpenSearch) =>
                    item.critical
                        ? ({
                              '&>td:first-of-type': {
                                  borderLeft: '4px solid',
                                  borderLeftColor: 'error.main',
                              },
                          } as SxProps)
                        : {}
                }
                fetchData={fetchData}
                localStorageKey="FlexyStoreDatatable"
                observers={[xIdSociete]}
                sx={{ marginBottom: '2.25em' }}
                preFilters={preFilters}
                filters={filters}
                onClickRow={(_: React.MouseEvent<HTMLElement>, item: FactureOpenSearch) => {
                    handleRowClick(item);
                }}
                rowsActions={rowActions}
            />
        </>
    );
};

export default FacturesTable;
